"use client";
import { PaletteShadeOptions } from "@mui/material";
import { PaletteOptions, createTheme } from "@mui/material/styles";
import type {} from "@mui/x-date-pickers/themeAugmentation";
import { COLORS_AB } from "./colorsAB";
import { muiInputLabelABStyles } from "./componentsStyleOverrides/muiInputLabelAB.styles";
import { muiOutlinedInputABStyles } from "./componentsStyleOverrides/muiOutlinedInputAB.styles";
import { typographyOptions } from "./typographyOptions";
import { DarkThemePalette, LightThemePalette, themeComponents } from "./theme";

const ThemeAB = createTheme();

const augmentColor = ({ color }: { color: PaletteShadeOptions }) =>
  ThemeAB.palette.augmentColor({ color });

const createColorStructure = (color: PaletteShadeOptions) => ({
  ...augmentColor({ color }),
  50: color[50],
  100: color[100],
  200: color[200],
  300: color[300],
  400: color[400],
  500: color[500],
  600: color[600],
  700: color[700],
  800: color[800],
  900: color[900],
});

export const LightThemePaletteAB: PaletteOptions = {
  ...LightThemePalette,
  primary: createColorStructure(COLORS_AB.PRIMARY_GREEN),
  secondary: createColorStructure(COLORS_AB.SECONDARY_GREEN),
};

export const DarkThemePaletteAB: PaletteOptions = {
  ...DarkThemePalette,
  mode: "dark",
  primary: createColorStructure(COLORS_AB.PRIMARY_GREEN_DARK),
  secondary: createColorStructure(COLORS_AB.SECONDARY_GREEN_DARK),
  background: {
    default: COLORS_AB.PRIMARY_GREEN_DARK[900],
    paper: COLORS_AB.PRIMARY_GREEN_DARK[800],
  },
};

const themeABConfig = createTheme({
  typography: typographyOptions,
  components: {
    ...themeComponents,
    MuiInputLabel: muiInputLabelABStyles,
    MuiOutlinedInput: muiOutlinedInputABStyles,
  },
});

export const lightThemeAB = createTheme({
  palette: LightThemePaletteAB,
  typography: themeABConfig.typography,
  // TS Performance improvement
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  components: themeABConfig.components as any,
});

export const darkThemeAB = createTheme({
  palette: DarkThemePaletteAB,
  typography: themeABConfig.typography,
  components: {
    ...themeABConfig.components,
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: `1px solid ${COLORS_AB.NEUTRAL_DARK[700]}`,
          color: "#ffffff",
        },
        head: {
          backgroundColor: COLORS_AB.PRIMARY_GREEN_DARK[800],
          color: "#ffffff",
        },
        body: {
          backgroundColor: COLORS_AB.PRIMARY_GREEN_DARK[900],
        },
      },
    },
    // TS Performance improvement
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } as any,
});

export { useTheme } from "@mui/material/styles";
